import React from "react"
import styled, { keyframes } from "styled-components"


const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}`

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Loader = styled.div`
  border: 16px solid #fff; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: ${ spin } 2s linear infinite;
  margin: 15px auto;
`

const SimpleLoader = () => (
  <LoadingWrapper>
    <Loader />
  </LoadingWrapper>
)

export default SimpleLoader



// WEBPACK FOOTER //
// ./src/components/SimpleLoader.jsx